export default "__VITE_ASSET__JYgjVy$R__"